(() => {
  if (window.ihMobilePurchaseInstalled) return;
  window.ihMobilePurchaseInstalled = true;
  function mount() {
    const info = document.querySelector('product-info');
    if (!info) return;
    const original = info.querySelector('button[name="add"]');
    if (!original) return;
    info.querySelectorAll('fieldset').forEach(field => {
      const choices = field.querySelectorAll('input[type="radio"]');
      if (choices.length === 1 && choices[0].value.trim().toLowerCase() === 'single') field.hidden = true;
    });
    if (info.querySelector('[data-mobile-purchase-bar]')) return;
    const bar = document.createElement('div');
    bar.className = 'mobile-purchase-bar';
    bar.dataset.mobilePurchaseBar = '';
    bar.setAttribute('aria-label', 'Selected product');
    bar.innerHTML = '<div><span data-mobile-purchase-selection></span><strong data-mobile-purchase-price></strong></div><button type="button" class="button button--primary" data-ih-feature="product-buying-facts" data-ih-action="sticky_add_to_cart" data-ih-resource="mobile-purchase">Add to cart</button>';
    info.append(bar);
    const button = bar.querySelector('button');
    const syncChat = () => {
      const host = document.getElementById('redo-chat-widget');
      const root = host?.shadowRoot;
      if (!root) return false;
      if (!root.querySelector('[data-ih-purchase-clearance]')) {
        const style = document.createElement('style');
        style.dataset.ihPurchaseClearance = '';
        style.textContent = '@media(max-width:749px){#redo-chat-widget-container > div:has(> #chat-widget-button){bottom:calc(20px + var(--ih-purchase-clearance,0px))!important}}';
        root.append(style);
      }
      const clearance = bar.hidden ? 0 : bar.getBoundingClientRect().height + (parseFloat(getComputedStyle(bar).bottom) || 0);
      host.style.setProperty('--ih-purchase-clearance', clearance + 'px');
      return true;
    };
    const update = () => {
      const activeButton = info.querySelector('button[name="add"]');
      if (!activeButton) { bar.hidden = true; return; }
      const facts = info.querySelector('[data-purchase-facts]');
      const selection = [...(facts?.querySelectorAll('p') || [])].filter(p => /^(Size|Finish|Length)\b[^:]*:/.test(p.textContent.trim())).map(p => p.textContent.replace(/^(Size|Finish|Length)\b[^:]*:\s*/, '').trim()).join(' · ');
      bar.querySelector('[data-mobile-purchase-selection]').textContent = selection || info.querySelector('[data-mobile-product-title]')?.textContent || document.title;
      const price = info.querySelector('.price:not(.price--on-sale) .price-item--regular, .price--on-sale .price-item--sale');
      bar.querySelector('[data-mobile-purchase-price]').textContent = price?.textContent.trim() || '';
      const adding = activeButton.classList.contains('loading');
      button.disabled = activeButton.disabled || activeButton.getAttribute('aria-disabled') === 'true';
      button.setAttribute('aria-busy', String(adding));
      button.textContent = adding ? 'Adding…' : activeButton.textContent.trim();
      bar.dataset.variantId = facts?.dataset.variantId || '';
      const rect = activeButton.getBoundingClientRect();
      bar.hidden = !window.matchMedia('(max-width: 749px)').matches || (rect.top >= 0 && rect.bottom <= window.innerHeight);
      syncChat();
    };
    button.addEventListener('click', () => { const activeButton = info.querySelector('button[name="add"]'); if (activeButton && !activeButton.disabled) activeButton.click(); });
    new IntersectionObserver(update).observe(original);
    new MutationObserver(update).observe(original, { attributes: true, childList: true, subtree: true });
    info.addEventListener('change', () => setTimeout(update, 700));
    window.addEventListener('resize', update, { passive: true });
    const chatObserver = new MutationObserver(() => { if (syncChat()) chatObserver.disconnect(); });
    chatObserver.observe(document.body, { childList: true, subtree: true });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('product-info:loaded', mount);
  document.addEventListener('shopify:section:load', mount);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => { mount(); document.querySelector('product-info button[name="add"]')?.dispatchEvent(new Event('change', { bubbles: true })); });
})();
